const state = {
    collectionsAll: [],
    error: null
};

export default state;
